module.exports = __webpack_public_path__ + "img/CAPP-2020-video.38c68516.webp";